<script setup>

</script>

<template>
  <div>
    <div>Customer Operation - Custom Integration</div>
  </div>
</template>

<style scoped>

</style>
